// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentIxStatus, ContentIxStatusList } from "../schema";
import { serialize_ContentIxStatus_internal, deserialize_ContentIxStatus_internal } from "./ContentIxStatus";

export function serialize_ContentIxStatusList_internal(value: ContentIxStatusList): unknown {
  return ((value: { items: ContentIxStatus[] }): unknown => {
    return {
      items: ((value: ContentIxStatus[]): unknown => {
        return value.map((value: ContentIxStatus): unknown => {
          return serialize_ContentIxStatus_internal(value);
        });
      })(value["items"]),
    };
  })(value);
}
export function serialize_ContentIxStatusList(obj: ContentIxStatusList): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentIxStatusList_internal(obj));
}
export function deserialize_ContentIxStatusList_internal(value: unknown): ParserResult<ContentIxStatusList> {
  return ((
    value: unknown,
  ): ParserResult<{
    items: ContentIxStatus[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ContentIxStatusList]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ContentIxStatusList]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "items")) {
      return { success: false, reason: `[#/components/schemas/ContentIxStatusList/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
    }
    const parsed_items = ((): ParserResult<ContentIxStatus[]> => {
      return ((value: unknown): ParserResult<ContentIxStatus[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ContentIxStatusList/items]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ContentIxStatus> => {
          return deserialize_ContentIxStatus_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ContentIxStatusList/items]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["items"]);
    })();
    if (!parsed_items.success) {
      return { success: false, reason: parsed_items.reason };
    }
    return { success: true, value: { items: parsed_items.value } };
  })(value);
}
export function deserialize_ContentIxStatusList(str: string): ParserResult<ContentIxStatusList> {
  return deserialize_ContentIxStatusList_internal(parseJsonWithNumbersAsBigint(str));
}
